var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconCrmActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.7834 4.51667L11.4751 2.025C10.6501 1.55 9.3584 1.55 8.5334 2.025L4.1834 4.53333C2.4584 5.7 2.3584 5.875 2.3584 7.73333V12.2583C2.3584 14.1167 2.4584 14.3 4.21673 15.4833L8.52507 17.975C8.94173 18.2167 9.47507 18.3333 10.0001 18.3333C10.5251 18.3333 11.0584 18.2167 11.4667 17.975L15.8167 15.4667C17.5417 14.3 17.6417 14.125 17.6417 12.2667V7.73333C17.6417 5.875 17.5417 5.7 15.7834 4.51667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 12.7083C11.4959 12.7083 12.7084 11.4958 12.7084 10C12.7084 8.50423 11.4959 7.29167 10.0001 7.29167C8.50431 7.29167 7.29175 8.50423 7.29175 10C7.29175 11.4958 8.50431 12.7083 10.0001 12.7083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconCrmActive);
export default __webpack_public_path__ + "static/media/menu_icon_crm_active.7b9907de830b8e9f2eadd18e26b1d5b5.svg";
export { ForwardRef as ReactComponent };